(function() {
  var proto;

  proto = window.Handsontable.Core.prototype;

  proto.getFirstRenderedRow = function() {
    return this.view.wt.wtViewport.rowsRenderCalculator.startRow;
  };

  proto.getFirstVisibleRow = function() {
    return this.view.wt.wtViewport.rowsVisibleCalculator.startRow;
  };

  proto.getFirstRenderedColumn = function() {
    return this.view.wt.wtViewport.columnsRenderCalculator.startColumn;
  };

  proto.getFirstVisibleColumn = function() {
    return this.view.wt.wtViewport.columnsVisibleCalculator.startColumn;
  };

  proto.getLastRenderedRow = function() {
    return this.view.wt.wtViewport.rowsRenderCalculator.endRow;
  };

  proto.getLastVisibleRow = function() {
    return this.view.wt.wtViewport.rowsVisibleCalculator.endRow;
  };

  proto.getLastRenderedColumn = function() {
    return this.view.wt.wtViewport.columnsRenderCalculator.endColumn;
  };

  proto.getLastVisibleColumn = function() {
    return this.view.wt.wtViewport.columnsVisibleCalculator.endColumn;
  };

  proto.isRowBeforeViewport = function(row) {
    return row < this.getFirstVisibleRow() && row >= 0;
  };

  proto.isRowAfterViewport = function(row) {
    return row > this.getLastVisibleRow();
  };

  proto.isColumnBeforeViewport = function(column) {
    return column < this.getFirstVisibleColumn() && column >= 0;
  };

  proto.isColumnAfterViewport = function(column) {
    return column > this.getLastVisibleColumn();
  };

  proto.isLastRowFullyVisible = function() {
    return this.getLastVisibleRow() === this.getLastRenderedRow();
  };

  proto.isLastColumnFullyVisible = function() {
    return this.getLastVisibleColumn() === this.getLastRenderedColumn();
  };

  proto.getRenderedColumnsCount = function() {
    if (this.view.wt.cloneOverlay instanceof window.WalkontableDebugOverlay) {
      return this.view.wt.getSetting('totalColumns');
    } else if (this.view.wt.cloneOverlay instanceof window.WalkontableLeftOverlay || this.view.wt.cloneOverlay instanceof window.WalkontableCornerOverlay) {
      return this.view.wt.getSetting('fixedColumnsLeft');
    } else {
      return this.view.wt.wtViewport.columnsRenderCalculator.count;
    }
  };

  proto.getRenderedRowsCount = function() {
    if (this.view.wt.cloneOverlay instanceof window.WalkontableDebugOverlay) {
      return this.view.wt.getSetting('totalRows');
    } else if (this.view.wt.cloneOverlay instanceof window.WalkontableTopOverlay || this.view.wt.cloneOverlay instanceof window.WalkontableCornerOverlay) {
      return this.view.wt.getSetting('fixedRowsTop');
    }
    return this.view.wt.wtViewport.rowsRenderCalculator.count;
  };

  proto.getVisibleRowsCount = function() {
    return this.view.wt.wtViewport.rowsVisibleCalculator.count;
  };

  proto.allRowsInViewport = function() {
    return this.view.wt.getSetting('totalRows') === this.getVisibleRowsCount();
  };

  proto.getVisibleColumnsCount = function() {
    return this.view.wt.wtViewport.columnsVisibleCalculator.count;
  };

  proto.allColumnsInViewport = function() {
    return this.view.wt.getSetting('totalColumns') === this.getVisibleColumnsCount();
  };

}).call(this);
